import React, { Component } from 'react'
import PropTypes from 'prop-types'

import ConfigTable from 'components/custom/ConfigTable/index'

import {TableCell} from 'react-toolbox/lib/table'
import Input from 'components/fulcrum/input/Input'

class CpuConfigItem extends Component {
  render() {
    const {
      curPart,
    } = this.props

    const partModelTableHeadContent = {
        architecture: <TableCell key={0}>Architecture</TableCell>,
        brand: <TableCell key={1}>Brand</TableCell>,
        classification: <TableCell key={2}>Classification</TableCell>,
        modelName: <TableCell key={3}>Model Name</TableCell>
    }
    return (
      <div>
        <ConfigTable
          tableHeadContent={partModelTableHeadContent}
          configSource={[curPart]}
        />
      </div>
    )
  }
}

CpuConfigItem.propTypes = {
  curPart: PropTypes.array.isRequired,
}

export default CpuConfigItem
